import { logAppInfo } from "@shared/utils/errors/errorLogger";

type PaymentLogLevel = "info" | "warning" | "error";

interface PaymentLogger {
  info: (message: string, data?: Record<string, unknown>) => void;
  warn: (message: string, data?: Record<string, unknown>) => void;
  error: (message: string, data?: Record<string, unknown>) => void;
}

function breadcrumb(
  category: string,
  message: string,
  level: PaymentLogLevel,
  data?: Record<string, unknown>
): void {
  logAppInfo(message, { category, level, data });
}

/**
 * Creates a scoped Sentry breadcrumb logger for payment modules.
 *
 * @param category - The calling module's file name (without extension).
 *   This becomes the Sentry breadcrumb `category` used for filtering.
 *   Examples: `"handlePaymentError"`, `"StripePaymentGateway"`, `"YunoPaymentGateway"`
 */
export function createPaymentLogger(category: string): PaymentLogger {
  return {
    info: (message: string, data?: Record<string, unknown>) =>
      breadcrumb(category, message, "info", data),
    warn: (message: string, data?: Record<string, unknown>) =>
      breadcrumb(category, message, "warning", data),
    error: (message: string, data?: Record<string, unknown>) =>
      breadcrumb(category, message, "error", data),
  };
}
